import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'miscellaneousAccounting.deleteModal.title',
    defaultMessage: 'Delete Miscellaneous Accounting Record',
  },
  confirmationText: {
    id: 'miscellaneousAccounting.deleteModal.confirmationText',
    defaultMessage: 'Are you sure you want to delete this record?',
  },
  warningBanner: {
    id: 'miscellaneousAccounting.deleteModal.warningBanner',
    defaultMessage:
      'Deleting this record will remove it from the current voucher. ' +
      'If the voucher has already been submitted, it will be returned to Draft ' +
      'and a new submission will be required.',
  },
  cancel: {
    id: 'miscellaneousAccounting.deleteModal.cancel',
    defaultMessage: 'Cancel',
  },
  confirm: {
    id: 'miscellaneousAccounting.deleteModal.confirm',
    defaultMessage: 'Confirm',
  },
});
